module.exports = __webpack_public_path__ + "media/images/crime-b48691e5185836aaa65cfd959093960a.png";